import { AfterViewInit, Component, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { ReportFilter } from '../../../features/experiences/interfaces/reports-filter.interface';
import AirDatepicker from 'air-datepicker';
import localeEs from 'air-datepicker/locale/es';
import { ReportsService } from 'src/app/shared/services/reports/reports.service';
import { FormControl } from '@angular/forms';
import { DateTime } from 'luxon';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { getSessionUserData } from 'src/app/shared/states/session-user/session-user.selectors';
import { sessionUserData } from 'src/app/shared/interfaces/states-data';
import { ModalOverlayDirective } from 'src/app/shared/directives/modal-overlay.directive';

@Component({
  selector: 'app-filter-report',
  templateUrl: './filter-report.component.html',
  styleUrls: ['./filter-report.component.scss']
})
export class FilterReportComponent implements OnChanges, AfterViewInit {

  reportsBase: ReportFilter[] = [
    {
      title: 'Ventas',
      description: 'Ventas de una función especifica por rango de fechas',
      permission: 'REPORTE_VENTAS_EXP',
      url: 'sales',
      isRequiredFunctions: true,
      isRequiredExperience: true,
      isRequiredUserId: false,
      filter: [
        {
          type: "date",
          id: "start_date",
          name: "Fecha de inicio",
          value: "",
          required: true
        },
        {
          type: "date",
          id: "end_date",
          name: "Fecha de fin",
          value: "",
          required: true
        },
        // {
        //   type: "checkbox",
        //   id: "sale_channel_id",
        //   name: "Taquilla/Online",
        //   value: false,
        //   required: true
        // }
      ]
    },
    {
      title: 'Constancia de boletaje',
      url: 'proof-tickets',
      permission: 'REPORTE_CONSTANCIA_BOLETAJE_EXP',
      isRequiredFunctions: true,
      isRequiredExperience: true,
      isRequiredUserId: false,
      description: 'Constancia de boletaje de una función especifica',
      filter: []
    },
    {
      title: 'Taquilla',
      description: 'Taquilla de una función especifica por rango de fechas',
      permission: 'REPORTE_TAQUILLA_EXP',
      url: 'ticket-office',
      isRequiredFunctions: true,
      isRequiredExperience: true,
      isRequiredUserId: true,
      filter: [
        {
          type: "date",
          id: "start_date",
          name: "Fecha de inicio",
          value: "",
          required: true
        },
        {
          type: "date",
          id: "end_date",
          name: "Fecha de fin",
          value: "",
          required: true
        }
      ]
    },
    {
      title: 'Boletos',
      description: 'Boletos vendidos de una función especifica por rango de fechas',
      permission: 'REPORTE_BOLETOS_EXP',
      url: 'tickets',
      isRequiredFunctions: false,
      isRequiredExperience: false,
      isRequiredUserId: false,
      filter: [
        {
          type: "date",
          id: "start_date",
          name: "Fecha de inicio",
          value: "",
          required: true
        },
        {
          type: "date",
          id: "end_date",
          name: "Fecha de fin",
          value: "",
          required: true
        }
      ]
    },
    {
      title: 'Reporte de Productor',
      permission: 'REPORTE_PRODUCTOR_EXP',
      description: 'Reporte de Productor por rango de fechas',
      url: 'producer',
      isRequiredFunctions: true,
      isRequiredExperience: true,
      isRequiredUserId: false,
      filter: [
        {
          type: "date",
          id: "start_date",
          name: "Fecha de inicio",
          value: "",
          required: true
        },
        {
          type: "date",
          id: "end_date",
          name: "Fecha de fin",
          value: "",
          required: true
        }
      ]
    },
  ]
  reports: ReportFilter[] = [];
  reportSelected: ReportFilter | null = null;
  itemControls: FormControl[] = [];
  showFilter: boolean = false;
  protected ngUnsubscribe: Subject<void> = new Subject<void>();
  routeExperienceId: string | null = null;
  sessionUserState: sessionUserData = {};
  @Input() functions!: number;
  @Input() isModal: boolean = false;
  @Input() showBottom: boolean = true;
  @Input() filterReports: string[] = [];
  @Input() instance: number = 0;

  @ViewChild('functionSelectorOverlay', { static: false }) functionSelectorOverlay!: ModalOverlayDirective;

  constructor(
    public ReportsService: ReportsService,
    private _activatedRoute: ActivatedRoute,
    private store: Store<any>,
  ) {
    this.reports = structuredClone(this.reportsBase);
    // Si hay un experience id en ruta
    this._activatedRoute.parent?.paramMap
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((params: ParamMap) => {
        if (params.get('id_experience')) {
          this.routeExperienceId = params.get('id_experience');
        }
      });
    // Al recibir cambios del reducer - User
    this.store.pipe(select(getSessionUserData), takeUntil(this.ngUnsubscribe)).subscribe((data: sessionUserData) => {
      if (data) {
        // Se guarda en el componente local el estado obtenido
        this.sessionUserState = data;
      }
    });
    let reportFilter: ReportFilter[] = []
    this.reports.forEach((report) => {
      if (this.appValidateAccessExperience(report.permission)) {
        reportFilter.push(report)
      };
    })
    this.reports = reportFilter



  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.functions) {
      this.reports = this.reports.filter((report) => !report.isRequiredFunctions)
    }

  }

  ngAfterViewInit(): void {
    this.resetFilterAndSelectReport();
  }

  appValidateAccessExperience(action: string | null | undefined) {
    const requiredActions = this.sessionUserState.permissions_experience?.split(','); // Añade aquí las acciones que necesitas validar 

    if (action && requiredActions?.some(reqAction => action.includes(reqAction))) {
      // if (true) {
      return true;
    } else {
      return false;
    }
  }

  getReport(overlay: any) {

    if (!this.reportSelected) return

    let filterData = this.reportSelected?.filter?.reduce((acc: any, filter: any) => {
      if (filter.type == 'checkbox') {
        acc[filter.id] = filter.value == true ? 2 : 1;
      } else if (filter.type == 'date') {
        acc[filter.id] = filter.value;
      }
      return acc;
    }, {});

    if (this.reportSelected.url != 'producer') {

      if (this.reportSelected.isRequiredExperience) {
        filterData.experience_id = parseInt(this.routeExperienceId!);
      }
      if (this.reportSelected.isRequiredFunctions && this.functions) {
        filterData.functions_ids = [this.functions];
      }
      if (this.reportSelected.isRequiredUserId) {
        filterData.user_id = parseInt(this.sessionUserState.user_id!);
      }
    } else {

      filterData = {
        experienceId: this.routeExperienceId,
        functionsId: this.functions,
        fromDate: filterData.start_date,
        toDate: filterData.end_date,
      }

    }

    this.ReportsService.report(this.reportSelected.url, filterData).subscribe({
      next: (data: any) => {
        if (!data.data[0][`${this.reportSelected?.url}_report_xlsx_base64_data`]) return;
        this.descargarArchivoBase64ComoExcel(data.data[0][`${this.reportSelected?.url}_report_xlsx_base64_data`], `${this.reportSelected?.title}_${DateTime.now().toFormat('yyyy-MM-dd')} 
        .xlsx`);
        overlay.close();
        this.resetFilterAndSelectReport();
        this.showFilter = false
      },
      error: (error) => {
        console.log(error);
      }
    })
  }

  saveValueFilter(value: string, index: number) {
    this.reportSelected?.filter?.forEach((filter, i) => {
      if (i == index) {
        filter.value = value;
      }
    })
  }

  checkAndSelectReport() {
    if (this.reports.length == 1) {
      setTimeout(() => {
        this.selectReport(this.reports[0])
      }, 0);
    }
  }
  selectReport(report: ReportFilter) {
    this.reportSelected = report;
    setTimeout(() => {
      report.filter?.forEach((filter, i) => {
        if (filter.type == 'date') {
          new AirDatepicker(`#${filter.id}`, {
            locale: localeEs,
            timepicker: false,
            dateFormat: 'yyyy-MM-dd', // Set the date format to YYYY-MM-DD
            buttons: ['today', 'clear'],
            autoClose: false,
            position: 'top right',
            onSelect: (e: any) => {
              this.saveValueFilter(e.formattedDate, i);
            }
          });
        }
      })
    }, 500);


  }

  descargarArchivoBase64ComoExcel(base64Data: any, nombreArchivo: any) {
    try {
      // Elimina los metadatos al principio de la cadena, si existen
      const base64Regex = /^data:.+;base64,/;
      const pureBase64Data = base64Data.replace(base64Regex, "");

      const data = atob(pureBase64Data);
      const byteArray = new Uint8Array(data.length);
      for (let i = 0; i < data.length; i++) {
        byteArray[i] = data.charCodeAt(i);
      }
      const blob = new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = nombreArchivo;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error('Error al decodificar los datos base64:', error);
      // Aquí puedes agregar código para manejar el error, como mostrar un mensaje al usuario
    }
  }

  isValid(): boolean {
    let isValid = true;
    if (this.reportSelected) {
      if (this.reportSelected.isRequiredExperience) {
        if (!this.routeExperienceId) {
          isValid = false
        }
      }
      if (this.reportSelected.isRequiredFunctions) {
        if (!this.functions) {
          isValid = false
        }
      }
      if (this.reportSelected.filter?.filter((filter: any) => filter.type != 'checkbox').some((filter: any) => !filter.value)) {
        isValid = false
      }
    } else {
      isValid = false
    }
    return isValid
  }
  changeCheckBox(value: string, index: number) {
    this.reportSelected?.filter?.forEach((filter, i) => {
      if (i == index) {
        filter.value = value;
      }
    })
  }
  openModal() {
    if (this.isModal && this.functionSelectorOverlay) {
      this.functionSelectorOverlay.open();
    }
  }
  closeModal() {
    if (this.isModal && this.functionSelectorOverlay) {
      this.functionSelectorOverlay.close();
      this.resetFilterAndSelectReport();
    }
  }
  resetFilterAndSelectReport() {
    if (this.filterReports.length > 0) {
      this.reports = structuredClone(this.reportsBase.filter((report) => this.filterReports.includes(report.permission)))
    } else {
      this.reports = structuredClone(this.reportsBase)
    }
    this.checkAndSelectReport();
    this.reportSelected = null;
  }

}
